import { cashinBetsCollapsed$$, cashinOfferDataForBets$$, ticketIdsByBetId$$ } from '../subs';
import { useReframe } from 'nike-re-framejs';
import { isNotEmpty } from '../../../utils';

export const useBetsCashinOffers = betIds => {
    const { derefSub } = useReframe();
    return betIds
        .map(betId => derefSub(cashinOfferDataForBets$$(betId)))
        .filter(val => isNotEmpty(val))
        .flatten(1)
        .filter((elem, index, tickets) => tickets.indexOf(elem) === index);
};

export const useBetCashinCollapsed = betIds => {
    const { derefSub } = useReframe();
    return (
        betIds
            .filter(betId => derefSub(ticketIdsByBetId$$(betId)))
            .map(betId => derefSub(cashinBetsCollapsed$$(betId)))
            .flatten(1)
            .filter(Boolean).size > 0
    );
};
